import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-label',
  standalone: true,
  imports: [],
  templateUrl: './label.component.html'
})
export class LabelComponent {

  @Input()
  public label: string = '';

}
